import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

interface CountryFAQSectionProps {
  countryName: string;
}

const CountryFAQSection = ({ countryName }: CountryFAQSectionProps) => {
  const faqs = [
    {
      question: `How do I find the best therapist, psychologist, or psychotherapist in ${countryName}?`,
      answer: `Use our search filters to find therapists, psychologists, and psychotherapists in your specific city within ${countryName}. You can filter by specialty, availability, and whether they offer online or in-person sessions. All mental health professionals in our directory are licensed and verified.`
    },
    {
      question: `Are online therapy sessions with therapists and psychologists available in ${countryName}?`,
      answer: `Yes, many therapists, psychologists, and psychotherapists in ${countryName} offer online therapy sessions. This provides flexibility and convenience, allowing you to receive professional help from the comfort of your home.`
    },
    {
      question: `What types of therapy are available from therapists and psychologists in ${countryName}?`,
      answer: `Our network includes therapists, psychologists, and psychotherapists specializing in various therapeutic approaches including cognitive behavioral therapy (CBT), psychodynamic therapy, family therapy, couples counseling, and more. Each mental health professional's profile lists their specialties and approaches.`
    },
    {
      question: `How much does therapy cost with therapists and psychologists in ${countryName}?`,
      answer: `Therapy costs vary depending on the therapist, psychologist, or psychotherapist, location, and type of session. Many mental health professionals offer different pricing options and some may accept insurance. Contact therapists directly for specific pricing information.`
    },
    {
      question: `Can I book an appointment immediately with therapists or psychologists in ${countryName}?`,
      answer: `Many therapists, psychologists, and psychotherapists in our network offer flexible scheduling and some may have immediate availability. Use our "Therapy Now" feature to find mental health professionals who can see you quickly, or browse individual profiles to check availability.`
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-brand-gray-900 mb-12">
            Frequently Asked Questions About Therapists, Psychologists & Psychotherapists in {countryName}
          </h2>
          
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left hover:text-brand-blue-600 transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-brand-gray-600 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default CountryFAQSection;